export default __webpack_public_path__ + "static/media/tituloES.bcf9325b.png";